import axiosInstance from "../Interceptors/ResponseInterceptor";

export const getSiteById = async (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(`/sites-table/${id}`);
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in createPassword:", error);
      reject(error);
    }
  });
};
export const getStatusById = async (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(`/sites-table-status-bar/${id}`);
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in createPassword:", error);
      reject(error);
    }
  });
};

export const getActivitiesBySiteId = async (id, partnerId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/api/site-activities/siteid/${id}/${partnerId}`
      );
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in createPassword:", error);
      reject(error);
    }
  });
};

export const getStageMaster = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(`/api/stage-master`);
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in createPassword:", error);
      reject(error);
    }
  });
};
export const createActivitiesBySiteId = async (id, projectId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.post(
        `/api/site-activities/siteid/${id}`,
        {
          partnerId: projectId,
        }
      );
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in createPassword:", error);
      reject(error);
    }
  });
};
export const createNewSite = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      // console.log("payload", data);
      const response = await axiosInstance.post(`/sites`, data);
      resolve(response.data);
    } catch (error) {
      console.error("Error in createPassword:", error);
      reject(error);
    }
  });
};
export const updateSiteById = async (id, data) => {
  // console.log("id and data", id, data);
  return new Promise(async (resolve, reject) => {
    try {
      // console.log("payload", data);
      const response = await axiosInstance.patch(`/site/${id}`, data);
      resolve(response.data);
    } catch (error) {
      console.error("Error in createPassword:", error);
      reject(error);
    }
  });
};
